@if (loading) {
    <div id="preloader" class="preloader">
      <img [src]="'assets/logo-preload.jpg'" [style.opacity]="progress / 100" alt="Logo de Tropilleros">
      <p>{{ progress }}%</p>
    </div>
  }
  
  @if (!loading) {
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  }
  